// extracted by mini-css-extract-plugin
export default {"slugInput":"SlugInput_slugInput__vELGR"};